import * as React from 'react';
/**
 * AutoLayout Component
 */
var AutoLayout = function (_a) {
    var children = _a.children;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement("div", { className: 'autolayout' }, children);
};
export default AutoLayout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXV0b0xheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvYXV0b2xheW91dC9BdXRvTGF5b3V0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQTtBQUk5Qjs7R0FFRztBQUNILElBQU0sVUFBVSxHQUE4QixVQUFDLEVBQVk7UUFBVixRQUFRLGNBQUE7SUFDdkQseURBQXlEO0lBQ3pELE9BQU8sNkJBQUssU0FBUyxFQUFFLFlBQVksSUFBRyxRQUFRLENBQU8sQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFFRCxlQUFlLFVBQVUsQ0FBQSJ9